/**
 * 获取url上的参数
 * @param key
 * @param url
 * @returns {string|null}
 */
export default function getQueryFromURL(key: string = '', urlStr: string = ''): string | null {
  let url = urlStr;
  const reg: RegExp = RegExp(`(^|&)${key}=([^&]*)(&|$)`);
  if (!url) {
    url = window.location.href;
  }
  const search = url.split('?')[1];
  if (!search) return null;
  const val = search.match(reg);
  return val ? decodeURIComponent(val[2]) : null;
}
